import { render, staticRenderFns } from "./AllocationReportLocalSteps.vue?vue&type=template&id=098e7b3c"
import script from "./AllocationReportLocalSteps.vue?vue&type=script&lang=js"
export * from "./AllocationReportLocalSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports